import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";
import { InstallPrompt } from "./components/pwa/InstallPrompt";
import { UpdatePrompt } from "./components/pwa/UpdatePrompt";

// Lazy load route components for better initial bundle size
const Why = lazy(() => import("./pages/Why"));
const Success = lazy(() => import("./pages/Success"));
const Program = lazy(() => import("./pages/Program"));
const TalentManagement = lazy(() => import("./pages/TalentManagement"));
const Apply = lazy(() => import("./pages/Apply"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Contact = lazy(() => import("./pages/Contact"));
const Auth = lazy(() => import("./pages/Auth"));
const Admin = lazy(() => import("./pages/Admin"));
const CreatorPortalLanding = lazy(() => import("./pages/CreatorPortalLanding"));
const CreatorPortalDashboard = lazy(() => import("./pages/CreatorPortalDashboard"));
const BattleRequest = lazy(() => import("./pages/BattleRequest"));
const BattleInvite = lazy(() => import("./pages/BattleInvite"));
const Leaderboard = lazy(() => import("./pages/Leaderboard"));
const BattleStats = lazy(() => import("./pages/BattleStats"));
const AgencyPortal = lazy(() => import("./pages/AgencyPortal"));
const Install = lazy(() => import("./pages/Install"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-pulse text-lg">Loading...</div></div>}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/why" element={<Why />} />
            <Route path="/success" element={<Success />} />
            <Route path="/program" element={<Program />} />
            <Route path="/talent-management" element={<TalentManagement />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/creator-portal" element={<CreatorPortalLanding />} />
            <Route path="/creator-portal/dashboard" element={<CreatorPortalDashboard />} />
            <Route path="/battle-request" element={<BattleRequest />} />
            <Route path="/battle-invite/:token" element={<BattleInvite />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/stats" element={<BattleStats />} />
            <Route path="/agency-portal" element={<AgencyPortal />} />
            <Route path="/install" element={<Install />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <InstallPrompt />
        <UpdatePrompt />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
